import React, { useState } from 'react';

const MultiSelectDropdown = ({ options, placeholder, toggleOption, selectedOptions }) => {
  // const [selectedOptions, setSelectedOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(true);

  const isOptionSelected = (option) =>
    selectedOptions.includes(option);

  const toggleDropdown = () => setIsOpen(!isOpen);


  return (
    <div className="relative mt-8 w-full max-w-2xl sm:mt-14">
      <div className="flex min-h-12 flex-wrap items-center gap-2 rounded-xl border border-slate-300 bg-white p-2 shadow-sm">
      {selectedOptions.length === 0 && (
          <div className="px-1.5 text-sm text-slate-400">{placeholder}</div>
        )}
        {selectedOptions.map((option) => (
          <div
            key={option}
            className="flex items-center gap-1 rounded-lg bg-orange-50 px-2.5 py-1 text-sm font-medium text-[#211b4f] ring-1 ring-inset ring-orange-200"
          >
            {option}
            <button
              onClick={() => toggleOption(option)}
              className="ml-0.5 flex h-5 w-5 items-center justify-center rounded-md bg-transparent text-slate-500 transition-colors hover:bg-orange-100 hover:text-[#fb6635]"
            >
              &times;
            </button>
          </div>
        ))}
        <button onClick={toggleDropdown} className="ml-auto flex h-8 w-8 flex-none items-center justify-center rounded-lg text-xs text-slate-500 transition-colors hover:bg-slate-100 hover:text-[#211b4f]">
          &#9660;
        </button>
      </div>
      {isOpen && (
        <ul className="absolute z-10 mt-2 max-h-60 w-full overflow-auto rounded-xl border border-slate-200 bg-white p-1.5 shadow-xl">
          {options.map((option) => (
            <li
              key={option}
              onClick={(e) => {
                toggleOption(option);
                e.stopPropagation();
              }}
              className={`w-full cursor-pointer rounded-lg px-3 py-2.5 text-sm transition-colors ${isOptionSelected(option) ? 'bg-[#211b4f] font-semibold text-white' : 'text-slate-700 hover:bg-orange-50 hover:text-[#211b4f]'}`}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};


export default MultiSelectDropdown;